import { useAtomValue, useSetAtom, atom, useAtom } from "jotai";

export type SortBy = "color" | "fabric";

export const swatchSortByAtom = atom<SortBy>("color");

export const useSwatchSortByType = () => useAtom(swatchSortByAtom);
export const useSetSwatchSortByType = () => useSetAtom(swatchSortByAtom);
export const useSwatchSortByTypeValue = () => useAtomValue(swatchSortByAtom);
